import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";

@Component({
  // tslint:disable-next-line:component-selector
  selector: "button-drop-down",
  templateUrl: "button-dropdown.component.html"
})
export class ButtonDropDownComponent {
  @Input() values: any[];

  @Input() buttonName: any;

  @Output() onSelectTipo: EventEmitter<any> = new EventEmitter<any>();

  imposta(value: any) {
    console.log("value : ", value);
    this.onSelectTipo.emit(value.target.childNodes[0].nodeValue);
  }
}
